export const sorter = {
  name: "sorter" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M17 3.1a.9.9 0 0 1 .636.264l4.5 4.5a.9.9 0 1 1-1.272 1.272L17.9 6.173V20a.9.9 0 0 1-1.8 0V6.173l-2.964 2.963a.9.9 0 0 1-1.272-1.272l4.5-4.5A.9.9 0 0 1 17 3.1Zm-10 0a.9.9 0 0 1 .9.9v13.827l2.964-2.963a.9.9 0 1 1 1.272 1.272l-4.5 4.5a.9.9 0 0 1-1.272 0l-4.5-4.5a.9.9 0 0 1 1.272-1.272L6.1 17.827V4a.9.9 0 0 1 .9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["sorter"],
  category: "utility" as const,
};
